import instance from "../../../../../services/api";

export const getExternalMasterPayments = async (params = {}) => {
  return await instance(true)
    .get(`/partner/report/external_masters/payment/`, { params })
    .then(res => res?.data);
};
